import {spacing} from '../../_delonghi'
import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outterContainer: {
            gap: remCalc(16),
            flexDirection: 'column',
            marginTop: remCalc(5),
        },
        container: {
            flexDirection: 'column',
            gap: remCalc(5),
        },
        title: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        termsAndConditionsContainer: {
            textStyle: 'body-xxsmall',
            alignItems: 'center',
            gap: spacing.xxsmall,
        },
        outterRadioContainer: {
            gap: remCalc(16),
        },
        radioContainer: {
            textStyle: 'body-small',
            align: 'center',
        },
        itemContainer: {
            alignItems: 'center',
            gap: spacing.xxsmall,
        },
        textContainer: {
            gap: remCalc(5),
            flexDirection: 'row',
        },
        warrantyName: {
            position: 'relative',
            top: remCalc(2),
        },
        price: {
            as: 'span',
            fontWeight: 'bold',
            position: 'relative',
            top: remCalc(2),
        },
    },
}
